import {
  TEXT_BLOCK_ELEMENT_TYPE,
  IMAGE_BLOCK_ELEMENT_TYPE,
  EMPTY_BLOCK_ELEMENT_TYPE,
  LEGACY_FORM_BLOCK_ELEMENT_TYPE,
  JSON_BLOCK_ELEMENT_TYPE,
  FORM_BLOCK_ELEMENT_TYPE,
  ACCORDION_BLOCK_ELEMENT_TYPE,
  VIDEO_BLOCK_ELEMENT_TYPE,
  QUESTION_ANSWER_BLOCK_ELEMENT_TYPE,
} from '../../constants/types';

export const ELEMENT_TYPE_ICON = {
  [TEXT_BLOCK_ELEMENT_TYPE]: 'file alternate outline',
  [VIDEO_BLOCK_ELEMENT_TYPE]: 'file video outline',
  [IMAGE_BLOCK_ELEMENT_TYPE]: 'images outline',
  [EMPTY_BLOCK_ELEMENT_TYPE]: 'question circle outline',
  [LEGACY_FORM_BLOCK_ELEMENT_TYPE]: 'wpforms',
  [FORM_BLOCK_ELEMENT_TYPE]: 'wpforms',
  [JSON_BLOCK_ELEMENT_TYPE]: 'file code outline',
  [ACCORDION_BLOCK_ELEMENT_TYPE]: 'caret right',
  [QUESTION_ANSWER_BLOCK_ELEMENT_TYPE]: 'question circle outline',
};

export const ELEMENT_TYPE_LABEL = {
  [TEXT_BLOCK_ELEMENT_TYPE]: 'Rich-text Block',
  [VIDEO_BLOCK_ELEMENT_TYPE]: 'Video Block',
  [IMAGE_BLOCK_ELEMENT_TYPE]: 'Image(s) Block',
  [EMPTY_BLOCK_ELEMENT_TYPE]: 'Empty Block',
  [LEGACY_FORM_BLOCK_ELEMENT_TYPE]: 'Form Block',
  [FORM_BLOCK_ELEMENT_TYPE]: 'Form Block',
  [JSON_BLOCK_ELEMENT_TYPE]: 'JSON Block',
  [ACCORDION_BLOCK_ELEMENT_TYPE]: 'Accordion Block',
  [QUESTION_ANSWER_BLOCK_ELEMENT_TYPE]: 'Question Answer Block',
};

export const ACTION_NAMES = {
  onAddBlockAbove: 'onAddBlockAbove',
  onAddBlockBelow: 'onAddBlockBelow',
  onAddColumnLeft: 'onAddColumnLeft',
  onAddColumnRight: 'onAddColumnRight',
  onAddRowAbove: 'onAddRowAbove',
  onAddRowBelow: 'onAddRowBelow',
  onDeleteColumn: 'onDeleteColumn',
  onDeleteRow: 'onDeleteRow',
};

export const DELETE_COLUMN_CONFIRM_HEADER = 'Delete Column';
export const DELETE_COLUMN_CONFIRM_CONTENT =
  'Are you sure you want to delete this column? All content in this column will be removed.';

export const DELETE_ROW_CONFIRM_HEADER = 'Delete Row';
export const DELETE_ROW_CONFIRM_CONTENT =
  'Are you sure you want to delete this entire row? All content in this row will be removed.';

export const DELETE_CONFIRM_BY_ACTION = {
  [ACTION_NAMES.onDeleteColumn]: {
    header: DELETE_COLUMN_CONFIRM_HEADER,
    content: DELETE_COLUMN_CONFIRM_CONTENT,
  },
  [ACTION_NAMES.onDeleteRow]: {
    header: DELETE_ROW_CONFIRM_HEADER,
    content: DELETE_ROW_CONFIRM_CONTENT,
  },
};
